import { MenuItem, Select, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";

import { Stack } from "@mui/system";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { Link, matchPath, useLocation, useNavigate } from "react-router-dom";
import ArrowDownIcon from "../../../Assets/Icons/ArrowDownIcon.svg";
import { ColorScheme } from "../../../Themes/ColorScheme";
import { ApiContext } from "../../ApiContext";
import TooltipWrapper from "../../Common/TooltipWrapper";
import { UserContext } from "../../UserContext";

export const LocationSelector = () => {
	const debug = false;
	const { t } = useTranslation();
	const { setSelectedLocation, selectedLocation, user } =
		useContext(UserContext);
	const { ApiCall } = useContext(ApiContext);
	const [locations, setLocations] = useState([]);

	const location = useLocation();
	const navigate = useNavigate();

	const getLocations = () => {

		ApiCall("GET", "client/locations", null, null)
			.then((res) => {
				setLocations(res);
				if (selectedLocation == null) {
					setSelectedLocation(res[0]);
				}
			})
			.catch((err) => {
				if (debug) console.log(err);
			});
	};

	const match = matchPath(
		{
			path: "/locations/:id",
			exact: true,
			strict: true
		},
		location.pathname
	);

	const handleOnClick = (loc) => {
		setSelectedLocation(loc);

		getLocations();

		if (
			(match !== null &&
				location.pathname !== `/locations/${loc.id}`) ||
			location.pathname === "/locations"
		)
			navigate(`/locations/${loc.id}`);
	};

	useEffect(() => {
		if (selectedLocation == null) {
			return;
		}
		if (
			!Object.prototype.hasOwnProperty.call(
				selectedLocation,
				"id"
			) &&
			selectedLocation != null &&
			selectedLocation.id === undefined &&
			locations.length > 0
		) {
			// check if location is in the list, if not, navigate to locations page

			const checkLocation = locations.find((loc) =>
				location.pathname.split("/").includes(String(loc.id))
			);

			if (checkLocation) {
				setSelectedLocation(checkLocation);
			} else {
				setSelectedLocation(locations[0]);
			}
		}
	}, [locations]);

	useEffect(() => {
		// clear states if user changes
		setLocations([]);
		setSelectedLocation(null);
	}, [user]);

	useEffect(() => {
		getLocations();
	}, [selectedLocation]);

	return (
		<div
			style={{
				flexDirection: "row",
				display: "flex",
				alignItems: "center",
				width: "max-content"
			}}
		>
			{selectedLocation != null && selectedLocation.name !== undefined && (
				<>
					<Stack
						direction="row"
						justifyContent="space-between"
						alignContent="center"
					>
						<Link to={`/locations/${selectedLocation.id}`}>
							<TooltipWrapper title={t("menu.return_back")}>
								<Typography
									sx={{
										color: ColorScheme.secondary
									}}
								>
									{selectedLocation.name}
								</Typography>
							</TooltipWrapper>
						</Link>

						<div>
							<Select
								labelid="select-type-label"
								id="select-type"
								value={
									selectedLocation === undefined ||
									selectedLocation === null ||
									selectedLocation === ""
										? ""
										: selectedLocation.id
								}
								sx={{
									backgroundColor: ColorScheme.transparent,
									borderRadius: "0px",
									border: "hidden",

									/* opacity: 0, */
									position: "absolute",
									width: isMobile ? undefined : "400px",
									boxShadow: "none",
									".MuiOutlinedInput-notchedOutline": {
										border: 0
									},

									"&.Mui-focused .MuiOutlinedInput-notchedOutline":
										{
											border: 0
										},
									"&:hover .MuiOutlinedInput-notchedOutline":
										{
											border: 0
										},
									".MuiSelect-select": { padding: "0px" }
								}}
								renderValue={() => (
									<TooltipWrapper
										title={t("menu.select_location")}
									>
										<img
											style={{
												width: "15px",
												height: "15px",
												marginLeft: "10px",
												marginTop: "5px"
											}}
											src={ArrowDownIcon}
										/>
									</TooltipWrapper>
								)}
								inputProps={{
									IconComponent: () => null
								}}
							>
								{locations
									.sort((a, b) =>
										a.name.localeCompare(b.name)
									)
									.map((loc) => (
										<MenuItem
											value={loc.id}
											key={loc.id}
											onClick={() => handleOnClick(loc)}
										>
											{loc.name}
										</MenuItem>
									))}
							</Select>
						</div>
					</Stack>
				</>
			)}
		</div>
	);
};
